import { render, staticRenderFns } from "./GroupTransfer.vue?vue&type=template&id=12fa685d&"
import script from "./GroupTransfer.vue?vue&type=script&lang=js&"
export * from "./GroupTransfer.vue?vue&type=script&lang=js&"
import style0 from "./GroupTransfer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports